import _defineProperty from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { HTMLElement, createEvent, writeTask, readTask, h, Host, proxyCustomElement } from '@stencil/core/internal/client';
import { b as getIonMode } from './ionic-global.js';
import { c as componentOnReady } from './helpers.js';
var infiniteScrollCss = "ion-infinite-scroll{display:none;width:100%}.infinite-scroll-enabled{display:block}";

var InfiniteScroll = /*#__PURE__*/function (_HTMLElement) {
  _inherits(InfiniteScroll, _HTMLElement);

  var _super = _createSuper(InfiniteScroll);

  function InfiniteScroll() {
    var _this;

    _classCallCheck(this, InfiniteScroll);

    _this = _super.call(this);

    _this.__registerHost();

    _this.ionInfinite = createEvent(_assertThisInitialized(_this), "ionInfinite", 7);
    _this.thrPx = 0;
    _this.thrPc = 0;
    _this.didFire = false;
    _this.isBusy = false;
    _this.isLoading = false;
    /**
     * The threshold distance from the bottom
     * of the content to call the `infinite` output event when scrolled.
     * The threshold value can be either a percent, or
     * in pixels. For example, use the value of `10%` for the `infinite`
     * output event to get called when the user has scrolled 10%
     * from the bottom of the page. Use the value `100px` when the
     * scroll is within 100 pixels from the bottom of the page.
     */

    _this.threshold = '15%';
    /**
     * If `true`, the infinite scroll will be hidden and scroll event listeners
     * will be removed.
     *
     * Set this to true to disable the infinite scroll from actively
     * trying to receive new data while scrolling. This is useful
     * when it is known that there is no more data that can be added, and
     * the infinite scroll is no longer needed.
     */

    _this.disabled = false;
    /**
     * The position of the infinite scroll element.
     * The value can be either `top` or `bottom`.
     */

    _this.position = 'bottom';

    _this.onScroll = function () {
      var scrollEl = _this.scrollEl;

      if (!scrollEl || !_this.canStart()) {
        return 1;
      }

      var infiniteHeight = _this.el.offsetHeight;

      if (infiniteHeight === 0) {
        // if there is no height of this element then do nothing
        return 2;
      }

      var scrollTop = scrollEl.scrollTop;
      var scrollHeight = scrollEl.scrollHeight;
      var height = scrollEl.offsetHeight;
      var threshold = _this.thrPc !== 0 ? height * _this.thrPc : _this.thrPx;
      var distanceFromInfinite = _this.position === 'bottom' ? scrollHeight - infiniteHeight - scrollTop - threshold - height : scrollTop - infiniteHeight - threshold;

      if (distanceFromInfinite < 0) {
        if (!_this.didFire) {
          _this.isLoading = true;
          _this.didFire = true;

          _this.ionInfinite.emit();

          return 3;
        }
      } else {
        _this.didFire = false;
      }

      return 4;
    };

    return _this;
  }

  _createClass(InfiniteScroll, [{
    key: "thresholdChanged",
    value: function thresholdChanged() {
      var val = this.threshold;

      if (val.lastIndexOf('%') > -1) {
        this.thrPx = 0;
        this.thrPc = parseFloat(val) / 100;
      } else {
        this.thrPx = parseFloat(val);
        this.thrPc = 0;
      }
    }
  }, {
    key: "disabledChanged",
    value: function disabledChanged() {
      var disabled = this.disabled;

      if (disabled) {
        this.isLoading = false;
        this.isBusy = false;
      }

      this.enableScrollEvents(!disabled);
    }
  }, {
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var contentEl;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                contentEl = this.el.closest('ion-content');

                if (contentEl) {
                  _context.next = 4;
                  break;
                }

                console.error('<ion-infinite-scroll> must be used inside an <ion-content>');
                return _context.abrupt("return");

              case 4:
                _context.next = 6;
                return new Promise(function (resolve) {
                  return componentOnReady(contentEl, resolve);
                });

              case 6:
                _context.next = 8;
                return contentEl.getScrollElement();

              case 8:
                this.scrollEl = _context.sent;
                this.thresholdChanged();
                this.disabledChanged();

                if (this.position === 'top') {
                  writeTask(function () {
                    if (_this2.scrollEl) {
                      _this2.scrollEl.scrollTop = _this2.scrollEl.scrollHeight - _this2.scrollEl.clientHeight;
                    }
                  });
                }

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }

      return connectedCallback;
    }()
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.enableScrollEvents(false);
      this.scrollEl = undefined;
    }
    /**
     * Call `complete()` within the `ionInfinite` output event handler when
     * your async operation has completed. For example, the `loading`
     * state is while the app is performing an asynchronous operation,
     * such as receiving more data from an AJAX request to add more items
     * to a data list. Once the data has been received and UI updated, you
     * then call this method to signify that the loading has completed.
     * This method will change the infinite scroll's state from `loading`
     * to `enabled`.
     */

  }, {
    key: "complete",
    value: function () {
      var _complete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this3 = this;

        var scrollEl, prev;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                scrollEl = this.scrollEl;

                if (!(!this.isLoading || !scrollEl)) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                this.isLoading = false;

                if (this.position === 'top') {
                  /**
                   * New content is being added at the top, but the scrollTop position stays the same,
                   * which causes a scroll jump visually. This algorithm makes sure to prevent this.
                   * (Frame 1)
                   *    - complete() is called, but the UI hasn't had time to update yet.
                   *    - Save the current content dimensions.
                   *    - Wait for the next frame using _dom.read, so the UI will be updated.
                   * (Frame 2)
                   *    - Read the new content dimensions.
                   *    - Calculate the height difference and the new scroll position.
                   *    - Delay the scroll position change until other possible dom reads are done using _dom.write to be performant.
                   * (Still frame 2, if I'm correct)
                   *    - Change the scroll position (= visually maintain the scroll position).
                   *    - Change the state to re-enable the InfiniteScroll.
                   *    - This should be after changing the scroll position, or it could
                   *    cause the InfiniteScroll to be triggered again immediately.
                   * (Frame 3)
                   *    Done.
                   */
                  this.isBusy = true; // ******** DOM READ ****************
                  // Save the current content dimensions before the UI updates

                  prev = scrollEl.scrollHeight - scrollEl.scrollTop; // ******** DOM READ ****************

                  requestAnimationFrame(function () {
                    readTask(function () {
                      // UI has updated, save the new content dimensions
                      var scrollHeight = scrollEl.scrollHeight; // New content was added on top, so the scroll position should be changed immediately to prevent it from jumping around

                      var newScrollTop = scrollHeight - prev; // ******** DOM WRITE ****************

                      requestAnimationFrame(function () {
                        writeTask(function () {
                          scrollEl.scrollTop = newScrollTop;
                          _this3.isBusy = false;
                        });
                      });
                    });
                  });
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function complete() {
        return _complete.apply(this, arguments);
      }

      return complete;
    }()
  }, {
    key: "canStart",
    value: function canStart() {
      return !this.disabled && !this.isBusy && !!this.scrollEl && !this.isLoading;
    }
  }, {
    key: "enableScrollEvents",
    value: function enableScrollEvents(shouldListen) {
      if (this.scrollEl) {
        if (shouldListen) {
          this.scrollEl.addEventListener('scroll', this.onScroll);
        } else {
          this.scrollEl.removeEventListener('scroll', this.onScroll);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _class;

      var mode = getIonMode(this);
      var disabled = this.disabled;
      return h(Host, {
        class: (_class = {}, _defineProperty(_class, mode, true), _defineProperty(_class, 'infinite-scroll-loading', this.isLoading), _defineProperty(_class, 'infinite-scroll-enabled', !disabled), _class)
      });
    }
  }, {
    key: "el",
    get: function get() {
      return this;
    }
  }], [{
    key: "watchers",
    get: function get() {
      return {
        "threshold": ["thresholdChanged"],
        "disabled": ["disabledChanged"]
      };
    }
  }, {
    key: "style",
    get: function get() {
      return infiniteScrollCss;
    }
  }]);

  return InfiniteScroll;
}(HTMLElement);

InfiniteScroll = /*@__PURE__*/proxyCustomElement(InfiniteScroll, [0, "ion-infinite-scroll", {
  "threshold": [1],
  "disabled": [4],
  "position": [1],
  "isLoading": [32],
  "complete": [64]
}]);

function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }

  var components = ["ion-infinite-scroll"];
  components.forEach(function (tagName) {
    switch (tagName) {
      case "ion-infinite-scroll":
        if (!customElements.get(tagName)) {
          customElements.define(tagName, InfiniteScroll);
        }

        break;
    }
  });
}

var IonInfiniteScroll = InfiniteScroll;
var defineCustomElement = defineCustomElement$1;
export { IonInfiniteScroll, defineCustomElement };